import Inline from '../blots/inline';

class Link extends Inline {
  static create(value) {
    const node = super.create(value);
    value = this.sanitize(value);
    node.setAttribute('href', value);
    const ch = value.substr(0, 1);
    if (ch !== '/' && ch !== '#' && value.substr(0, 7) !== 'mailto:') {
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
    }
    return node;
  }

  static formats(domNode) {
    return domNode.getAttribute('href');
  }

  static sanitize(url) {
    return sanitize(url, this.PROTOCOL_WHITELIST) ? relativeUrl(url) : this.SANITIZED_URL;
  }

  format(name, value) {
    if (name !== this.statics.blotName || !value) {
      super.format(name, value);
      return;
    }
    value = this.constructor.sanitize(value);
    this.domNode.setAttribute('href', value);
    this.domNode.setAttribute('data-title', value);
  }
}
Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function sanitize(url, protocols) {
  const anchor = document.createElement('a');
  anchor.href = url;
  const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

function relativeUrl(url) {
  const baseLoc = window.location;
  const loc = document.createElement('a');
  loc.href = url;
  if (baseLoc.origin !== loc.origin) {
    return loc.href;
  }
  if (baseLoc.pathname !== loc.pathname ||
    baseLoc.search !== loc.search) {
    return loc.pathname + loc.search + loc.hash;
  }
  if (baseLoc.href === loc.href) {
    return loc.hash || loc.pathname + loc.search + loc.hash;
  }
  return loc.hash;
}

export { Link as default, sanitize };
